import { CountdownAd } from 'models/CountdownAd';
import { PageState } from 'models/PageState';

interface CountdownProp {
  countdownAd: CountdownAd;
}

export const isCountdown = (obj: unknown): obj is CountdownProp =>
  'countdownAd' in (obj as CountdownProp);

export const getCountDownAd = (state: PageState) =>
  isCountdown(state.currentPage) ? state.currentPage.countdownAd : undefined;
